export const VENDOR_CAPABILITIES = Object.freeze(["insights", "stores", "tableOrdering", "customerOrdering", "customerHistory", "tableServiceRequests", "groupOrdering"]);

export const DEFAULT_VENDOR_CAPABILITIES = Object.freeze({
  insights: false,
  stores: false,
  tableOrdering: true,
  customerOrdering: true,
  customerHistory: true,
  tableServiceRequests: false,
  groupOrdering: false,
});

export function normalizeVendorCapabilities(input, businessType = "restaurant") {
  const defaults = businessType === "restaurant"
    ? DEFAULT_VENDOR_CAPABILITIES
    : { ...DEFAULT_VENDOR_CAPABILITIES, tableOrdering: false };
  const result = VENDOR_CAPABILITIES.reduce((result, key) => {
    const value = input?.[key];
    result[key] = typeof value === "boolean" ? value : defaults[key];
    return result;
  }, {});
  if (!result.customerOrdering) { result.customerHistory = false; result.tableServiceRequests = false; }
  if (!result.tableOrdering) result.tableServiceRequests = false;
  if (businessType !== "restaurant") { result.customerOrdering = false; result.customerHistory = false; result.tableServiceRequests = false; result.groupOrdering = false; }
  return result;
}

export function resolveVendorCapability({ vendor, isOwner, capability }) {
  if (!VENDOR_CAPABILITIES.includes(capability)) return false;
  const values = normalizeVendorCapabilities(vendor?.capabilities, vendor?.businessType);
  if (!values[capability]) return false;
  return isOwner;
}
